export enum AgentResponseFilter {
  WithoutFirstResponse = 0,
  WithFirstResponse = 1,
}
